import React from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
    RupeeIcon
} from "../../Styles/InputStyle2";
import { Select, MenuItem } from "@mui/material";
// import DropzoneImageUpload from "../Properties/DropzoneImageUpload";
import { FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";

const EditPurchaseDetails = ({ onClose, stepOneData, setSelectedForm,addAssetFunctionMutate,isaddAssetLoading,setEditPurchaseDetails,setViewDetail }) => {
    const initialValues = {
        depreciation: "",
        purchasePrice: "20500",
        purchaseDate: "",
        vendorName: "",
    };

    const handleSubmit = (values) => {
        const payload = {
            purchaseDate: values.purchaseDate,
            purchasePrice: values.purchasePrice,
            depreciation: values.depreciation,
            vendorName: values.vendorName,
        }
        // setSelectedForm("3");
        console.log(payload);
    };
    const handleBack = () => {
        setEditPurchaseDetails(false);
        setViewDetail(true);
    }
    const handleCross = () => {
        setEditPurchaseDetails(false);
        setViewDetail(true);
    }

    return (
        <Container>
            <Header>
                <Title>{"Edit Purchase Details"}</Title>
                <CloseButton onClick={handleCross}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                        <Form className="px-2">
                            {/* <ModalSubHeading>Step 2</ModalSubHeading> */}
                            {/* <ModalHeading>Financial/Purchase Details</ModalHeading> */}
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="purchaseDate">Purchased Date </Label>
                                        <FieldWrappers className="bg-gray-100">
                                            <CalendarIcon />
                                            <Field
                                                type="date"
                                                name="purchaseDate"
                                                id="purchaseDate"
                                                autoComplete="off"
                                                className="pl-6 "
                                                disabled
                                                value={values.purchaseDate}
                                                max={new Date().toISOString().split("T")[0]}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="purchasePrice">Purchased Price </Label>
                                        <FieldWrappers className="bg-gray-100">
                                            <RupeeIcon />
                                            <Field
                                                type="text"
                                                name="purchasePrice"
                                                id="purchasePrice"
                                                className="w-full truncate pl-6 text-gray-500"
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                value={values.purchasePrice}
                                                disabled
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="depreciation">Depreciation Rate (%) </Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="depreciation"
                                                id="depreciation"
                                                autoComplete="off"
                                                maxLength={18}

                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="vendorName">Vendor Name *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="vendorName"
                                                id="vendorName"
                                                autoComplete="off"

                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <div className="flex items-end justify-end -mt-2">
                                        <Vendor type="button" onClick={() => {
                                            // setIsShowAddExpenses(false);
                                            // setIsAddVendor(true);

                                        }}><FaUserPlus className="mr-1 mt-0.5"
                                            />Add Vendor</Vendor>
                                    </div>
                                    {/* <InputGroup>
                                <Label htmlFor="document">
                                    Upload Receipt<span className="text-red-500">*</span>
                                </Label>
                                <div>
                                    <DropzoneImageUpload
                                        setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                        componentFor="document"
                                    />
                                </div>
                            </InputGroup> */}


                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleBack}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    Submit
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>

    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;

export default EditPurchaseDetails;